module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Fish-9b8df952c5ae9176b2ebe5ba52f5a268.svg";